import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number", 
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};

const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};

const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class YouTubeModuleAttributeFactory {
    /**
     * @param parent {AutomationAttributesGenerator}
     */
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.commentReceived()
        );
    }

    commentReceived() {
        const e = AutomationEventTypes.YOUTUBE.COMMENT_RECEIVED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "YouTube Comment Received", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.commentId`, "Comment ID", vt.STRING),
                ga(context, `${prefix}.videoId`, "Video ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Channel ID", vt.STRING),
                ga(context, `${prefix}.text`, "Comment Text", vt.STRING),
                ga(context, `${prefix}.authorDisplayName`, "Author Name", vt.STRING),
                ga(context, `${prefix}.authorChannelId`, "Author Channel ID", vt.STRING),
                ga(context, `${prefix}.authorChannelUrl`, "Author Channel URL", vt.STRING),
                ga(context, `${prefix}.authorProfileImageUrl`, "Author Profile Image", vt.STRING),
                ga(context, `${prefix}.likeCount`, "Like Count", vt.NUMBER),
                ga(context, `${prefix}.publishedAt`, "Published At", vt.DATETIME),
                ga(context, `${prefix}.updatedAt`, "Updated At", vt.DATETIME),
                ga(context, `${prefix}.status`, "Status", vt.STRING),
                ga(context, `${prefix}.moderationStatus`, "Moderation Status", vt.STRING),
                ga(context, `${prefix}.parentId`, "Parent Comment ID", vt.STRING),
                ga(context, `${prefix}.video`, "Video Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.video.videoId`, "Video ID", vt.STRING),
                    ga(context, `${prefix}.video.title`, "Video Title", vt.STRING),
                    ga(context, `${prefix}.video.description`, "Video Description", vt.STRING),
                    ga(context, `${prefix}.video.thumbnail`, "Video Thumbnail", vt.STRING),
                    ga(context, `${prefix}.video.channelTitle`, "Channel Title", vt.STRING),
                    ga(context, `${prefix}.video.viewCount`, "View Count", vt.NUMBER),
                    ga(context, `${prefix}.video.likeCount`, "Like Count", vt.NUMBER),
                    ga(context, `${prefix}.video.commentCount`, "Comment Count", vt.NUMBER),
                ]),
            ])
        ];
    }
}

export default YouTubeModuleAttributeFactory;
